import type Listing from 'data/listing';
import { capitalizeWords } from '@zoocasa/node-kit/strings';

export default function generateNearbyListingsDescription(listingInfo?: Listing) {
  if (!listingInfo) {
    return;
  }
  const { bedrooms, styleName, neighbourhoodName, city } = listingInfo;

  // Fallback values
  const bedroomsText = bedrooms ? `${bedrooms}+ Bed ` : '';
  const neighbourhoodText = neighbourhoodName ? `${neighbourhoodName}, ` : '';

  // Generate the description
  const description = `${bedroomsText}${capitalizeWords(styleName)}s <b>For Sale</b> Near ${neighbourhoodText}${city}`;

  return description;
}
